module.exports = __webpack_public_path__ + "img/qu_cr.5eeb0ad.jpg";